"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERROR_INFO = void 0;
const ERROR_INFO = exports.ERROR_INFO = 'error-info';
